import React, { Component } from "react";
import axios from "axios";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import dayjs from "dayjs";
import TablePagination from "@mui/material/TablePagination";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import Serverurl from "./Apiurl";

import {
  Container,
  Paper,
  Grid,
  Button,
  Typography,
  CircularProgress,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Box,
  MenuItem,
  FormControl,
  Select
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PrintIcon from "@mui/icons-material/Print";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

export default class ExpensesReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fromDate: dayjs().startOf("month"),
      toDate: dayjs().endOf("month"),
      projectId: "",
      projects: [],
	   categoryId: "",     
  categories: [],    

 projectarray: [],
  projectarrauto: [],openExportDialog: false,
  selectedProject: null,  
  
  selectedCategory: null,

      reportData: [],
      loading: false,
      error: "",
      totalHeads: 0,
      totalAmount: 0,
	  
	   page: 0,
  rowsPerPage:50,
  totalRecords: 0
  
    };
  }

  componentDidMount() {
	   if(localStorage.getItem("VRuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Userlogin'
          })
		  }
let strname="Expenses Report";   
			 this.props.parentsCallback(
           strname
        );
 
  this.fetchReportDataAuto();
}

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
Handlesearch= (e) => {
	  this.fetchReportDataAuto();
}

   fetchReportDataAuto = () => {
    const {
  fromDate,
  toDate,
  projectId,
  categoryId
} = this.state;

    this.setState({ loading: true, error: "" });
axios.get(Serverurl +"ajaxlaborexpensesreport.php" +"?action=getlaborexpensesreport" +"&from_date=" + fromDate.format("YYYY-MM-DD") +"&to_date=" + toDate.format("YYYY-MM-DD") +"&project_id=" + projectId +"&category_id=" + categoryId +"&index=" + this.state.page +"&maxrecord=" + this.state.rowsPerPage +"&orderby=WorkDate DESC")
      .then((res) => {
        const data = res.data || [];

        let totalHeads = 0;
        let totalAmount = 0;

        data.forEach((item) => {
          totalHeads += Number(item.Heads || 0);
          totalAmount += Number(item.Amount || 0);
        });

        this.setState({
             reportData: data,
    totalHeads,
    totalAmount,
    totalRecords: data?.[0]?.count || 0,
    loading: false
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
          error: "Unable to fetch report data"
        });
      });
  };

  fetchReportData = (e) => {
  e.preventDefault();

  this.setState(
    {
      page: 0
    },
    () => this.fetchReportDataAuto()
  );
  };
exportExcel = () => {
  const { reportData, totalAmount, totalHeads } = this.state;

  if (!reportData.length) return alert("No data available");

  const excelData = reportData.map((r) => ({
    Project: r.ProjectName,
    Category: r.CategoryName,
    Date: r.WorkDate ? dayjs(r.WorkDate).format("DD-MM-YYYY") : "",
    Heads: r.Heads,
    "Daily Wage": r.DailyWage,
    Amount: r.Amount
  }));

  excelData.push({
    Project: "",
    Category: "",
    Date: "",
    Heads: totalHeads,
    "Daily Wage": "",
    Amount: totalAmount
  });

  const ws = XLSX.utils.json_to_sheet(excelData);
  const wb = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(wb, ws, "Labor Expenses");

  const buffer = XLSX.write(wb, {
    bookType: "xlsx",
    type: "array"
  });

  saveAs(new Blob([buffer]), "Labor_Expense_Report.xlsx");

  this.setState({ openExportDialog: false });
};
exportPDF = () => {
  const { reportData, totalHeads, totalAmount } = this.state;

  if (!reportData.length) return alert("No data available");

  const doc = new jsPDF("l", "mm", "a4");

  doc.setFontSize(14);
  doc.text("Labor Expense Report", 14, 15);

  const head = [["Project", "Category", "Heads", "Daily Wage", "Amount"]];

  const body = reportData.map((r) => [
    r.ProjectName,
    r.CategoryName,
    r.Heads,
    Number(r.DailyWage || 0).toLocaleString("en-IN"),
    Number(r.Amount || 0).toLocaleString("en-IN")
  ]);

  body.push([
    "TOTAL",
    "",
    totalHeads,
    "",
    totalAmount.toLocaleString("en-IN")
  ]);

  autoTable(doc, {
    head,
    body,
    startY: 25
  });

  doc.save("Labor_Expense_Report.pdf");

  this.setState({ openExportDialog: false });
};

  handlePageChange = (event, newPage) => {
  this.setState(
    {
      page: newPage
    },
    () => this.fetchReportDataAuto()
  );
};

handleRowsChange = (event) => {
  this.setState(
    {
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0
    },
    () => this.fetchReportDataAuto()
  );
};


/*PROJECT AUTOEXTENDER*/
onloadProjectBind = (event) => {
axios.get(Serverurl +"ajaxprojects.php" +"?action=getallprojectautoextender" +"&pj_projectname=" + encodeURIComponent(event.target.value))
    .then((resp) => {
      let strCust = [];

      (resp.data || []).forEach((row) => {
        const item = {
          title: row.pj_projectname,
          pj_id: row.pj_id,
          rowindex: row.rowindex
        };

        const found = strCust.some(
          (el) => el.pj_id === row.pj_id
        );

        if (!found) {
          strCust.push(item);
        }
      });

      this.setState({
        projectarray: resp.data || [],
        projectarrauto: strCust
      });
    });
};

onProjectChange = (event, value) => {
  this.setState({
    selectedProject: value,
    projectId: value ? value.pj_id : ""
  });
};

onloadCategoryBind = (event) => {
axios.get(Serverurl +"ajaxlaborexpensesreport.php" +"?action=getcategorydropdown" +"&search=" + encodeURIComponent(event.target.value))
    .then((resp) => {
      let strCat = [];

      (resp.data || []).forEach((row) => {
        const item = {
          title: row.CategoryName,
          CategoryId: row.CategoryId
        };

        const found = strCat.some(
          (el) => el.CategoryId === row.CategoryId
        );

        if (!found) {
          strCat.push(item);
        }
      });

      this.setState({
        categories: strCat
      });
    })
    .catch((err) => console.error(err));
};

  render() {
 const {
  fromDate,
  toDate,
  projectId,
  projects,
  categoryId,
  categories,
  reportData,
  loading,
  error,
  totalHeads,
  totalAmount
} = this.state;

    return (
       <React.Fragment>

  

   

       <div className="searchmaster">
            <ul>
                                <li>
            <p> From Date</p>
        <p><LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker className="inputcntlparent"
		disableFuture
          value={fromDate}
          onChange={(newValue) => this.setState({ fromDate: newValue })}
          format="DD/MM/YYYY"
          slotProps={{
            textField: {
              fullWidth: true,
              size: "small"
            }
          }}
        /></LocalizationProvider>
 </p> </li>

     
      <li>
            <p>
          To Date
        </p>
         <p><LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker className="inputcntlparent"
		disableFuture
          value={toDate}
          onChange={(newValue) => this.setState({ toDate: newValue })}
          format="DD/MM/YYYY"
          slotProps={{
            textField: {
              fullWidth: true,
              size: "small"
            }
          }}
        />  </LocalizationProvider> </p> </li>

    <li>
            <p>
    Project
  </p>
         <p>

  <Autocomplete className="inputcntlparent"
  options={this.state.projectarrauto}
  value={this.state.selectedProject}
  onChange={this.onProjectChange}
  getOptionLabel={(option) => option.title || ""}
  renderInput={(params) => (
    <TextField
      {...params}
      size="small"
      placeholder="Search Project"
      onChange={this.onloadProjectBind}
    />
  )}
  renderOption={(props, option) => (
    <li {...props}>
      {option.title}
    </li>
  )}
  fullWidth
/>
  </p> </li>

    <li>
            <p>  

    Category
  </p>
 <p>
  <Autocomplete className="inputcntlparent"
  options={this.state.categories}
  value={this.state.selectedCategory || null}
  onChange={(event, value) => {
    this.setState({
      selectedCategory: value,
      categoryId: value ? value.CategoryId : ""
    });
  }}
  getOptionLabel={(option) => option.title || ""}
  renderInput={(params) => (
    <TextField
      {...params}
      size="small"
      placeholder="Search Category"
      onChange={this.onloadCategoryBind}
    />
  )}
  renderOption={(props, option) => (
    <li {...props}>{option.title}</li>
  )}
  fullWidth
/>
 </p></li>
	  

    
    <li><p>&nbsp;</p>
            <p>
	  
        <Button
          type="submit"
          
          variant="contained"
          size="small"
         endIcon={<SearchIcon />}
               onClick={this.Handlesearch}    
        >
          {loading ? "Loading..." : "Search"}
        </Button> <Button
  variant="contained"
size="small"
  onClick={() => this.setState({ openExportDialog: true })}
>
  EXPORT
</Button>
       </p>

    </li>
  </ul>
</div>


         <Paper>
          <TableContainer component={Paper}>
            <Table>

              {/* HEADER */}
            <TableHead>
  <TableRow>  <TableCell >Date</TableCell>
    <TableCell >Project</TableCell>
    <TableCell >Category</TableCell>
  
    <TableCell >Photo</TableCell>
    <TableCell >Remarks</TableCell>
    <TableCell >Amount</TableCell>
  </TableRow>
</TableHead>

              {/* BODY */}
             <TableBody>
  {reportData.length ? (
    reportData.map((row, i) => (
      <TableRow key={i}>     <TableCell>
          {row.WorkDate
            ? dayjs(row.WorkDate).format("DD/MM/YYYY")
            : ""}
        </TableCell>
        <TableCell>{row.ProjectName}</TableCell>
        <TableCell>{row.CategoryName}</TableCell>

        {/* DATE */}
   

        {/* PHOTO */}
        <TableCell>
          {row.Photo ? (
            <img
              src={`${Serverurl}uploads/${row.Photo}`}
              alt="NA"
              width="50"
              height="50"
              style={{ borderRadius: 5 }}
            />
          ) : (
            "-"
          )}
        </TableCell>

        {/* REMARKS */}
        <TableCell>{row.Remarks || "-"}</TableCell>

        {/* AMOUNT */}
        <TableCell>
  Rs. {parseFloat(row.Amount).toLocaleString("en-IN")}
</TableCell>
      </TableRow>
    ))
  ) : (
    !loading && (
      <TableRow>
        <TableCell colSpan={6} align="center">
          No Records Found
        </TableCell>
      </TableRow>
    )
  )}
</TableBody>

              {/* FOOTER */}
             <TableFooter>
  <TableRow>
    <TableCell colSpan={5} align="right">
      <b>Grand Total</b>
    </TableCell>
    <TableCell>
  <b>  Rs. {totalAmount.toLocaleString("en-IN")}</b>
</TableCell>
    <TableCell />
  </TableRow>
</TableFooter>

            </Table>
			
			<TablePagination
			 rowsPerPageOptions={[50, 100, 150, 200, 250]}  
  component="div"
  count={this.state.totalRecords}
  page={this.state.page}
  onPageChange={this.handlePageChange}
  rowsPerPage={this.state.rowsPerPage}
  onRowsPerPageChange={this.handleRowsChange}
/>
		<Dialog
  open={this.state.openExportDialog}
  onClose={() => this.setState({ openExportDialog: false })}
>
  <DialogTitle>Export Labor Expense Report</DialogTitle>

  <DialogContent>
    <div style={{ display: "flex", gap: 20, justifyContent: "center", marginTop: 10 }}>
      
      <Button
        variant="contained"
        onClick={this.exportExcel}
        sx={{ backgroundColor: "#2e7d32" }}
      >
        Excel
      </Button>

      <Button
        variant="contained"
        onClick={this.exportPDF}
        sx={{ backgroundColor: "#d32f2f" }}
      >
        PDF
      </Button>

    </div>
  </DialogContent>

  <DialogActions>
    <Button onClick={() => this.setState({ openExportDialog: false })}>
      Cancel
    </Button>
  </DialogActions>
</Dialog>	
          </TableContainer>

        </Paper>
      </React.Fragment>
    );
  }
}

